import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { storage } from '@/utils/storage';
import { useAuth } from '@/contexts/AuthContext';
import OnboardingCarousel from '@/components/OnboardingCarousel';
import SimplifiedDashboard from '@/components/SimplifiedDashboard';

export default function DashboardPage() {
  const location = useLocation();
  const { currentUser: user } = useAuth();
  const [plans, setPlans] = useState([]);
  const [showOnboarding, setShowOnboarding] = useState(false);

  // Clear guided mode flags when landing on dashboard (unless coming directly from guided mode)
  useEffect(() => {
    const referrer = document.referrer;
    if (!referrer.includes('/guided-mode') && !location.state?.fromGuidedMode) {
      localStorage.removeItem('guidedModeReturn');
      localStorage.removeItem('guidedModeNextStep');
    }
  }, [location.state]);

  const loadPlans = async () => {
    try {
      const allPlans = await storage.getPlans();
      setPlans(allPlans);
    } catch (error) {
      console.error('Error loading plans:', error);
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
    loadPlans();
  }, [location]);

  // Onboarding check
  useEffect(() => {
    if (!user) {
      setShowOnboarding(false);
      return;
    }

    const isGuest = user.isAnonymous || false;
    
    if (isGuest) {
      // Guest user - always show onboarding every time
      setShowOnboarding(true);
    } else {
      // Registered user - only show on first login
      const onboardingKey = `onboarding_seen_${user.uid}`;
      const hasSeenOnboarding = localStorage.getItem(onboardingKey);
      
      if (!hasSeenOnboarding) {
        setShowOnboarding(true);
      } else {
        setShowOnboarding(false);
      }
    }
  }, [user]);

  const handleOnboardingComplete = () => {
    setShowOnboarding(false);
    
    // For registered users (not guests), mark onboarding as seen
    if (user && !user.isAnonymous) {
      const onboardingKey = `onboarding_seen_${user.uid}`;
      localStorage.setItem(onboardingKey, 'true');
    }
  };

  // Show onboarding carousel if needed
  if (showOnboarding) {
    return <OnboardingCarousel onComplete={handleOnboardingComplete} />;
  }

  // Show the simplified dashboard (main hub)
  return <SimplifiedDashboard />;
}
